export class Settings {
    id : any;
    officeId : any;
    officeName : any;
    key : any;
    value : any;
    dateValue : any;
    activeStatus : any;
}
